import { useDispatch, useSelector } from "react-redux";
import { updatePassword } from "aws-amplify/auth";
import {
  onChecking,
  onNotChecking,
  onErrorMessage,
  onSuccesMessage,
  onQuizPatient,
} from "../store/secretary";

import { gosafeApi } from "../api";
import { translations } from "../helpers";

export const useSecretaryStore = () => {
  const dispatch = useDispatch();
  const { checking, errorMessage, successMessage, schedule, quizPatient } =
    useSelector((state) => state.secretary);

  //---------------------------------------------------//

  //---------------------------------------------------//

  const startGetPatientSurgeries = async (patientId) => {
    try {
      dispatch(onChecking());
      const { data } = await gosafeApi.get(
        `patient/patientSurgery/${patientId}`
      );
      dispatch(onNotChecking());
      return data;
    } catch (error) {
      dispatch(onNotChecking());
      return (
        translations[error.response.data.message] || error.response.data.message
      );
    }
  };

  //---------------------------------------------------//

  //---------------------------------------------------//

  //---------------------------------------------------//

  //---------------------------------------------------//

  //---------------------------------------------------//

  return {
    //methods

    startGetPatientSurgeries,

    //props
    checking,
    errorMessage,
    successMessage,

    quizPatient,
    schedule,
  };
};
